import { createContext, useContext } from 'react';
import './workspaceTheme.scss';

// Keep the reference Tasks screens and every Payroll Hub descendant untouched.
export const usesWorkspaceTheme = pathname => !/^\/(?:tasks|payroll-hub)(?:\/|$)/i.test(pathname);

export const WorkspaceThemeContext = createContext(false);
export const useWorkspaceTheme = () => useContext(WorkspaceThemeContext);

export const WorkspaceSurface = ({ children }) => (
  <WorkspaceThemeContext.Provider value={true}>
    <div className='workspace-theme workspace-auth'>{children}</div>
  </WorkspaceThemeContext.Provider>
);
